import {useIsFeatureActive} from '@aboutyou/feature-flags';
import React, {useState} from 'react';
import {useScrollEffect} from 'react-viewport-utils';
import {PushNotification} from '../../PushNotification/PushNotification';

export const OrderSuccessWebPush = () => {
  const {isActive} = useIsFeatureActive('web_mobile_push_notifications');
  const [showPushNotification, setShowPushNotification] = useState(false);

  useScrollEffect(
    scroll => {
      if (isActive && scroll.y >= 200) {
        setShowPushNotification(true);
      }
    },
    {
      deferUpdateUntilIdle: true,
      priority: 'low',
      disableScrollUpdates: !isActive,
    },
    [isActive],
  );

  if (showPushNotification) {
    return <PushNotification type="osp_push_trg" />;
  }

  return null;
};
